import type { RouteRecordRaw } from 'vue-router'

const route: RouteRecordRaw = {
  path: '/system-tools/oss-upload-test',
  name: 'ossUploadTest',
  component: () => import('@/layouts/index.vue'),
  meta: { title: 'OSS 上传测试', icon: 'i-lucide:cloud-upload' },
  children: [{
    path: '',
    name: 'ossUploadTestPage',
    component: () => import('@/views/system_tools/oss-upload-test.vue'),
    meta: { title: '上传与归档', icon: 'i-lucide:cloud-upload' },
  }],
}

export default route
